import { ControlledParameter } from '../controlled-parameter';
import { Tba } from '../tba';

export class TbaTransactionsModalPayload {
  tba: Tba;
  parameters: ControlledParameter[];
}
